<script>
export default {
  props: {
    responsive: {
      type: Boolean,
      required: false,
      default: true
    },
    success: {
      type: Boolean,
      required: false,
      default: false
    },
    big: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<template>
  <div>
    <div class="Loader" :class="{responsive: responsive, success: success, big: big}"></div>
  </div>
</template>

<style scoped>
@-webkit-keyframes rotate-Loader {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotate-Loader {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-webkit-keyframes rotateSpinner-Loader {
  100% {
    -webkit-transform: rotate(-360deg);
    transform: rotate(-360deg);
  }
}
@keyframes rotateSpinner-Loader {
  100% {
    -webkit-transform: rotate(-360deg);
    transform: rotate(-360deg);
  }
}
@-webkit-keyframes dot-Loader {
  0% {
    background: #fff;
    box-shadow: inset 0 0 0 43px #fff;
  }
  25% {
    background: var(--pink);
    box-shadow: inset 0 0 0 36px #fff;
  }
  50% {
    background: #fff;
    box-shadow: inset 0 0 0 43px #fff;
  }
  75% {
    background: var(--purple);
    box-shadow: inset 0 0 0 36px #fff;
  }
  50% {
    background: #fff;
    box-shadow: inset 0 0 0 43px #fff;
  }
}
@keyframes dot-Loader {
  0% {
    background: #fff;
    box-shadow: inset 0 0 0 43px #fff;
  }
  25% {
    background: var(--pink);
    box-shadow: inset 0 0 0 36px #fff;
  }
  50% {
    background: #fff;
    box-shadow: inset 0 0 0 43px #fff;
  }
  75% {
    background: var(--purple);
    box-shadow: inset 0 0 0 36px #fff;
  }
  50% {
    background: #fff;
    box-shadow: inset 0 0 0 43px #fff;
  }
}

.Loader {
  -webkit-animation: rotate-Loader 3s infinite linear;
  animation: rotate-Loader 3s infinite linear;
  background-image: linear-gradient(var(--purple), var(--pink));
  border-radius: 50%;
  height: 80px;
  overflow: hidden;
  position: relative;
  width: 80px;
  -webkit-backface-visibility: hidden;
  -webkit-mask-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC);
}
.Loader::before {
  -webkit-animation: rotateSpinner-Loader 13s infinite linear;
  animation: rotateSpinner-Loader 13s infinite linear;
  background: rgba(255, 255, 255, 0.5);
  content: "";
  height: 40px;
  left: 0;
  position: absolute;
  top: 0;
  width: 40px;
  -webkit-transform-origin: 40px 40px;
  transform-origin: 40px 40px;
}
.Loader::after {
  -webkit-animation: dot-Loader 1.5s infinite;
  animation: dot-Loader 1.5s infinite;
  background: var(--pink);
  border-radius: 50%;
  box-shadow: inset 0 0 0 45px #fff;
  content: "";
  height: 70px;
  left: 5px;
  position: absolute;
  top: 5px;
  width: 70px;
}

.Loader.success {
  background-image: linear-gradient(var(--green-dark), var(--green));
}

.Loader.big {
  height: 140px;
  width: 140px;
}
.Loader.big::before {
  height: 70px;
  width: 70px;
  -webkit-transform-origin: 70px 70px;
  transform-origin: 70px 70px;
}
.Loader.big::after {
  height: 130px;
  width: 130px;
  background: white;
  animation: none;
}

@media (max-width: 768px) {
  .Loader.responsive {
    height: 60px;
    width: 60px;
  }
  .Loader.responsive::before {
    height: 30px;
    width: 30px;
    -webkit-transform-origin: 30px 30px;
    transform-origin: 30px 30px;
  }
  .Loader.responsive::after {
    height: 50px;
    width: 50px;
  }

  .Loader.big.responsive {
    height: 80px;
    width: 80px;
  }
  .Loader.big.responsive::before {
    height: 40px;
    width: 40px;
    -webkit-transform-origin: 40px 40px;
    transform-origin: 40px 40px;
  }
  .Loader.big.responsive::after {
    height: 70px;
    width: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payment/_Loader.vue